import { LinkIcon, MapPinIcon, CalendarDaysIcon } from "@heroicons/react/24/outline";
import PageWrapper from "../component/sharedComponents/PageWrapper";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
    DocumentTextIcon,
    StarIcon,
    BookmarkIcon,
    Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import avatar from "../assets/images/Avatar.avif"
import ReviewsSection from "../component/profile/ReviewsSection";
import PostsBase from "../component/sharedComponents/PostsBase";
import { getMyCompany } from "../slices/7-company/thunk";
import MainButton from "../component/sharedComponents/MainButton";
import CreatePostModal from "../component/layers/Layout/CreatePostModal";

const CompanyProfilePage = () => {
    const { i18n, t } = useTranslation();
    // const { profile } = useSelector((state) => state.myProfile);
    const { myCompany } = useSelector((state) => state.company);
    const [searchParams] = useSearchParams();
    const initialTab = searchParams.get("tab") || "posts";
    const [activeTab, setActiveTab] = useState(initialTab);
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    useEffect(() => {
        dispatch(getMyCompany());
    }, [dispatch]);

    const profileTabs = [
        { name: "posts", icon: DocumentTextIcon },
        { name: "reviews", icon: StarIcon },

    ];

    const formatJoinedDate = (isoDate, locale = "en") => {
        if (!isoDate) return "";
        const date = new Date(isoDate);
        return new Intl.DateTimeFormat(locale, { month: "long", year: "numeric" }).format(date);
    };


    const [companyData, setCompanyData] = useState({
        name: "",
        bio: "",
        about: "",
        website: "",
        location: "",
        followers: 0,
        following: 0,
        avatar: avatar,
    });

    useEffect(() => {
        const isArabic = i18n.language === "ar";

        setCompanyData({
            name: isArabic ? myCompany?.name_AR : myCompany?.name_EN,
            bio: isArabic ? myCompany?.short_bio_AR : myCompany?.short_bio_EN,
            about: isArabic ? myCompany?.about_AR : myCompany?.about_EN,
            website: myCompany?.contactInfo?.website || "",
            location: myCompany?.contactInfo?.address || "",
            followers: myCompany?.followersCount || 0,
            following: myCompany?.followingCount || 0,
            avatar: myCompany?.profileImage || avatar,
        });
    }, [i18n.language, myCompany]);
    // console.log(myCompany)
    return (
        <PageWrapper>
            <div className="overflow-hidden ">

                {/* COVER */}
                <div className="relative w-full h-52">
                    {myCompany?.coverImage ?
                        <img
                            src={myCompany?.coverImage}
                            className="object-cover w-full h-full"
                            alt="cover"
                        />
                        : <div className="w-full h-44 dark:bg-bg-dark-tertiary bg-bg-light-tertiary lg:h-52">
                        </div>
                    }

                    {/* AVATAR */}
                    <img
                        // src={myCompany?.avatar || avatar}
                        src={myCompany?.logo || avatar}
                        alt="avatar"
                        className="absolute border-2 rounded-full h-28 w-28 lg:h-32 lg:w-32 lg:-bottom-16 -bottom-8 start-4 border-primary-light dark:border-primary"
                    />
                </div>

                {/* PROFILE INFO */}
                <div className="flex flex-col gap-6 px-4 pt-10 lg:pt-20 md:flex-row md:justify-between">

                    {/* LEFT INFO */}
                    <div>
                        <h1 className="text-2xl font-bold text-black dark:text-white">
                            {/* {myCompany?.fullName} */}
                            {companyData?.name}
                        </h1>
                        <p className="text-sm text-text-muted-light dark:text-text-muted-dark">
                            {/* @{myCompany?.code} */}
                            {/* {myCompany?.slug} */}
                        </p>

                        {/* BIO */}
                        <p className="max-w-xl mt-3 text-sm text-gray-700 dark:text-gray-300">
                            {/* {myCompany?.bio} */}
                            {/* {companyBio} */}
                            {companyData?.about}
                        </p>

                        {/* META */}
                        <div className="flex flex-wrap gap-5 mt-4 text-sm text-text-muted-light dark:text-text-muted-dark">

                            {myCompany?.location && (
                                <div className="flex items-center gap-1">
                                    <MapPinIcon className="w-4 h-4" />
                                    {/* <span>{myCompany?.location}</span> */}
                                    <span>{myCompany?.location}</span>
                                </div>
                            )}

                            {myCompany?.website && (
                                <div className="flex items-center gap-1 dark:text-primary text-primary-light">
                                    <LinkIcon className="w-4 h-4" />
                                    <a href={myCompany?.website} target="_blank" rel="noopener noreferrer" className="hover:underline">
                                        {/* {myCompany?.website} */}
                                        {myCompany?.website}
                                    </a>
                                </div>
                            )}

                            <div className="flex items-center gap-1">
                                <CalendarDaysIcon className="w-4 h-4" />
                                {t("profile.joined")} {formatJoinedDate(myCompany?.createdAt, i18n.language)}
                            </div>
                        </div>

                        {/* FOLLOW */}
                        {(companyData?.following !== 0 || companyData?.followers !== 0) &&
                            <div className="flex gap-6 mt-4">
                                <div>
                                    <span className="font-semibold text-black dark:text-white">
                                        {/* {company?.following} */}
                                        {companyData?.following}
                                    </span>{" "}
                                    <span className="text-text-muted-light dark:text-text-muted-dark">{t("profile.following")}</span>
                                </div>
                                <div>
                                    <span className="font-semibold text-black dark:text-white">
                                        {companyData?.followers}
                                    </span>{" "}
                                    <span className="text-text-muted-light dark:text-text-muted-dark">{t("profile.followers")}</span>
                                </div>
                            </div>
                        }
                    </div>

                    {/* RIGHT BUTTON */}
                    <div className="flex items-start">

                        <MainButton
                            onClick={() => setOpen(true)}
                        // className="px-5 py-2 text-sm transition-colors border rounded-xl border-border-light dark:border-border-dark hover:bg-bg-light-tertiary dark:hover:bg-bg-dark-tertiary"
                        >
                            {t("post.create")}
                        </MainButton>
                    </div>
                </div>

                {/* TABS */}
                <div className="w-full mt-8 border-b border-border-light dark:border-border-dark">
                    <div className="flex justify-between w-full ">
                        {profileTabs.map(tab => {
                            const Icon = tab.icon;
                            const active = activeTab === tab.name;

                            return (
                                <button
                                    key={tab.name}
                                    onClick={() => setActiveTab(tab.name)}
                                    className={`
          py-4 lg:text-sm text-sm font-medium relative w-1/2
          flex items-center justify-center gap-1
          transition-colors
          ${active
                                            ? "dark:text-white text-black"
                                            : "text-text-muted-light dark:text-text-muted-dark hover:text-black dark:hover:text-white"}
        `}
                                >
                                    <Icon className="w-3 h-3 lg:h-5 lg:w-5" />
                                    <span>{t(`profile.tabs.${tab.name}`)}</span>

                                    {active && (
                                        <span className="absolute bottom-0 left-0 w-full h-0.5 dark:bg-primary bg-primary-light rounded-full" />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* TAB CONTENT */}
                <div className="p-6">
                    {activeTab === "posts" && <PostsBase posts={myCompany?.Posts} />}
                    {activeTab === "reviews" && (
                        <ReviewsSection
                            comments={true}
                            reviews={myCompany?.Reviews}

                            onSubmit={(data) => {
                                // console.log("New Review:", data);
                            }}
                            giveReview={false}
                        />
                    )}
                    {/* {activeTab === "saved" && <PostsBase posts={fakePosts} />} */}
                    {/* {activeTab === "settings" && <div>Settings content</div>} */}
                </div>
            </div>
            <CreatePostModal isOpen={open} onClose={() => setOpen(false)} companyType={true} companyName={companyData?.name} company={myCompany} />

        </PageWrapper>
    );
};

export default CompanyProfilePage;
